export { default as View } from './View';
export type { ViewProps } from './types';
